import {mapActions, mapState} from 'vuex'
import {SMEQuickQuote} from '@api/sme'
import {smeClassId} from '@/utils/smePath'

export default {
  data() {
    return {
      step: 0,
    }
  },
  computed: {
    ...mapState('smeQuote', ['smeQuickForm']),
    type(){
      let {type} = this.$route.params
      return type
    },
    stocks_isrd_max(){
      return 30000000
    },
    classId(){
      return smeClassId[this.type]
    },
    smeOptions(){
      return this[`smeOptions${this.classId}`]||{}
    },
    total_area(){
      let {fl_area_of_work,fl_area_of_seat} = this.formData.basic_info
      return Number(fl_area_of_seat) + Number(fl_area_of_work)
    },
    public_liability(){
      return '10,000,000'
    }
  },
  watch: {
    smeQuickForm:{
      immediate:true,
      handler(val){
        if(val){
          Object.keys(this.formData).some(key=>{
            if(val[key]){
              this.formData[key] = val[key]||this.formData[key]
            }
          })
        }
      }
    }
  },
  methods: {
    ...mapActions('smeQuote', ['setSmeQuickForm','setEstimatedPremium']),
    handlerBack(){
      this.step -=1
      if(this.step<0)
        this.$router.back()
    },
    async handlerLessSave(){
      let data =  await this.$refs.occuption.submitForm()
      this.formData = {...this.formData,ec_detail:{...data}}
      await this.network().SMEQuickQuote(this.formData)
    },
    /*
    处理sme underwriting 逻辑，1.点击next 判断是否最大数，
    如果超过最大数跳转到选择用户---(quoting/customer) /  refer
   *  */
    handlerNext(max) {
      //todo
      let params = {}
      this.$refs['form'].validate(async (valid, rules) => {
        if( valid){
          if(this.step<max){
            this.$nextTick(()=>{
              this.$refs.form.clearValidate()
            })
          }
          if(this.step==max){
            let data =  await this.$refs.occuption.submitForm()
            this.formData = {...this.formData,ec_detail:{...data}}
            this.setSmeQuickForm(this.formData)
            await this.network().SMEQuickQuote(this.formData)
            return
          }
          this.step +=1
        }
      })
      // if(this.step>max)
      // {
      //   this.$router.push('/quoting/customer/sme')
      //   return
      // }
    },
    // 最後一個表單
    handlerLastForm(currentFormData, currentForm) {
    },
    network(){
      return{
        SMEQuickQuote:async (params)=>{
          let {data} = await SMEQuickQuote(params,this.classId)
          let {is_enable_case,estimated_premium_str} = data
          this.setSmeQuickForm(params)
          this.setEstimatedPremium(estimated_premium_str)
          // is_enable_case 1： 有效，可以進行下一步操作 Buy Policy | Download
          //is_enable_case 0： 無效，可以進入 Add Refer Case Ticket 進入人工單流程
          if(is_enable_case==1)
          {
            this.$router.push('/quoting/customer/sme')
          }
          else  this.$router.push(`/quoting/${this.type}/refer`)
        }
      }
    }
  }
}
